import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { clientConfig } from "./config";
import {MainTracker} from './PixelTrackers/MainTracker'
import {CustomErrorBoundary} from './components/CustomErrorBoundary/CustomErrorBoundary'
import * as OneSignal from './utils/OneSignal'
import './fonts.css'

const createApp = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  window.clientLogger && window.clientLogger.setMetaData({version:clientConfig.VERSION})

  root.render(
    <CustomErrorBoundary>
      <App />
    </CustomErrorBoundary>
  );
  MainTracker.init()
  OneSignal.init()
};

// create react app only after scripts framework is loaded
if (window.eventsTracking.loaded) {
  createApp();
} else {
  window.eventsTracking.onLoad(createApp);
}
